import { Component } from '@angular/core';
import { NavParams } from 'ionic-angular';

@Component({
    selector: 'page-scoreboard',
    templateUrl: 'scoreboard.html',
})
export class ScoreboardPage {

    scoreboard: any;
    matches: any;
    scoreboardImage: any;

    constructor(public navParams: NavParams) {
        this.scoreboard = this.navParams.get('scoreboard').score;
        this.matches = this.navParams.get('scoreboard').match;
        this.scoreboardImage = this.navParams.get('scoreboard').photo; 
    }
}


// WEBPACK FOOTER //
// ./src/pages/scoreboard/scoreboard.ts